import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export function useAnalysisNextQuery(slug: string) {
  return useQuery({
    queryKey: ['analysisNext', slug],
    retry: false,
    queryFn: async () => {
      return fetch(
        `/analysis/${slug}/next`,
        {
          method: 'GET'
        },
        schemas.AnalysisNextListDto
      );
    }
  });
}
